module.exports = __webpack_public_path__ + "snap.d46ce4e4.png";